module.exports = __webpack_public_path__ + "img/HPFM_axe_mobile.60f6accd.png";